import PlayerShotChart from "./PlayerShotChart";

export default PlayerShotChart;
